export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /home/daniel/www/navigator.palladium.cz/node_modules/d3-chord/src/array.js
// module id = ../../../node_modules/d3-chord/src/array.js
// module chunks = 0